/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
//const userDefaults = {
//  uid         : 0,          // From Auth
//  displayName : "John Doe", // From Auth
//  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
//  photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
//  status      : "online",
//  userRole    : "admin"
//}

//const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
//const getUserInfo = () => {
  //let userInfo = {}

  // Update property in user
  //Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    //userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
  //})

  // Include properties from localStorage
  //Object.keys(userInfoLocalStorage).forEach((key) => {
  // if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
  //})

  //return userInfo
//}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    veiculos: [],
    ultimosAvisos: [],
    corLocalidade: [],
    listaDivisao: [], 
    listaPedidosSelecionadosParaRoteirizar: [],  
    listaPoIsSelecionadosParaRoteirizar: [],
    listaConfiguracaoSomAviso: [],
    AppActiveUser           : null,
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,    
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    dadosRelogin: null,
    nomeCentral: 'CONCEPT',
    filtrosPesquisa : {
      agendaEventos: null,
      despesas: null,
      receitas: null, 
      fornecedores: null,
      categoriaPontoInteresse: null,
      pontoInteresse: null,
      tanqueCombustivel: null,
      comprasCombustivel: null,
      rotasViagens: null,
      zonasViagens: null,
      almoxarifados: null,
      bandaRodagem: null,
      dimensoes: null,
      fabricantes: null,
      modelos: null,
      motivoSucateamento: null,
      pneus: null,
      movimentacaoPneu: null,
      inspecaoPneu: null,
      pedidos: null,
      roteirizacoes: null,
      lojas: null,
      vendedores: null,
      zonas: null,
      tiposOcorrencias: null,
      motorista: null,
      divisaoMotorista: null,
      perimetros: null,
      divisaoVeiculos: null,
      corLocalidade: null,
      categoriaAvisos: null,
      mensagemTeclado: null,
      categoriaVeiculos: null,
      pontuacaoInfracao: null,
      pessoas : null,
      controleViagens: null,
      automatizadorRoteirizacao: null,
      eventosMonitriip: null,
      lancamentoAfericao: null,
      compraProduto: null,
      ocorrenciaVeiculo: null,
      integracaoFacchini: null,
      veiculosExternos: null    
    },
    dadosParaPercurso: {
      filtroVeiculoSelecionado: null,
      consolidadoPercursoSelecionado: null,
      dadosPopUpParametroHora: null
    }, 
    exibirMensagemDesatualizado: true,
    colunasGrid :{
        veiculo: true,
        ignicaoBloqueio: true,
        statusConexaoStatusAlimentacao:  true,
        placaKmHorimetro:  true,
        motorista:  true,
        velocidadeTempoParado: true,
        sensores: true,
        localizacaoUltimaAtualizacao: true,
        capacidadePeso: false,
        capacidadeVolume: false,						
        condutor: false,
        autonomia: false,
        autonomiaPorHora: false,
        latitude: false,
        longitude: false,
        placa: false,
        panico: false,
        dataHoraPanico: false,
        ignicao: false,
        statusPanico: false,
        idVeiculo: false,
        codigoModulo: false,
        marcaModulo: false,
        marca: false,
        modelo: false,
        tipoVeiculo: false,
        divisaoVeiculo: false,
        corNomeDivisao: false,
        velocidadeAtual: false,
        dataUltimoPacoteRecebido: false,
        dataUltimaAtualizacaoFmt2: false,
        tempoSemGPRS: false,
        tempoParadoEmMinutos: false,
        isDesatualizado: false,
        orientacao: false,
        possuiBloqueio: false,
        statusGPRS:  false,
        isBloqueado:  false,
        ultimoOdometro:  false,
        ultimoOdometroBkp:  false,
        ultimoHorimetro: false,
        ultimoHorimetroBkp: false,
        labelVeiculo:  false,
        possuiTeclado:  false,
        possuiSaida2:  false,
        possuiSaida3:  false,
        sensorRS232:  false,
        sensorRS232Instalado:  false,
        avisarVeiculoLigado:  false,
        avisarVeiculoDesligado:  false,
        statusAncoragem:  false,
        ultimaVoltagem:  false,
        semAlimentacaoExterna:  false,
        nivelBateriaModulo: false,
        nivelBateriaModuloBkp:  false,
        avisoAux0:  false,
        avisoAux1:  false,
        avisoAux2:  false,
        statusEntrada1:  false,
        statusEntrada2: false,
        statusEntrada3: false,
        statusEntrada4: false,
        statusSaida1:  false,
        statusSaida2: false,
        statusSaida3:  false,
        corVeiculo:  false,
        ultimoRPM:  false
    },
    configMapa:{
      agruparMapa: true,
      exibirNomeCidade: true,
      ocultarDetalhes: false,
      exibirGrid: true,
      exibirTransito: false,
      exibirIconesPoI: true
    },
    colunasGridMapa :{
      veiculo: true,
      ignicaoBloqueio: true,
      statusConexaoStatusAlimentacao:  true,
      placaKmHorimetro:  true,
      motorista:  true,
      velocidadeTempoParado: true,
      sensores: true,
      localizacaoUltimaAtualizacao: true,
      capacidadePeso: false,
      capacidadeVolume: false,						
      condutor: false,
      autonomia: false,
      autonomiaPorHora: false,
      latitude: false,
      longitude: false,
      placa: false,
      panico: false,
      dataHoraPanico: false,
      ignicao: false,
      statusPanico: false,
      idVeiculo: false,
      codigoModulo: false,
      marcaModulo: false,
      marca: false,
      modelo: false,
      tipoVeiculo: false,
      divisaoVeiculo: false,
      corNomeDivisao: false,
      velocidadeAtual: false,
      dataUltimoPacoteRecebido: false,
      dataUltimaAtualizacaoFmt2: false,
      tempoSemGPRS: false,
      tempoParadoEmMinutos: false,
      isDesatualizado: false,
      orientacao: false,
      possuiBloqueio: false,
      statusGPRS:  false,
      isBloqueado:  false,
      ultimoOdometro:  false,
      ultimoOdometroBkp:  false,
      ultimoHorimetro: false,
      ultimoHorimetroBkp: false,
      labelVeiculo:  false,
      possuiTeclado:  false,
      possuiSaida2:  false,
      possuiSaida3:  false,
      sensorRS232:  false,
      sensorRS232Instalado:  false,
      avisarVeiculoLigado:  false,
      avisarVeiculoDesligado:  false,
      statusAncoragem:  false,
      ultimaVoltagem:  false,
      semAlimentacaoExterna:  false,
      nivelBateriaModulo: false,
      nivelBateriaModuloBkp:  false,
      avisoAux0:  false,
      avisoAux1:  false,
      avisoAux2:  false,
      statusEntrada1:  false,
      statusEntrada2: false,
      statusEntrada3: false,
      statusEntrada4: false,
      statusSaida1:  false,
      statusSaida2: false,
      statusSaida3:  false,
      corVeiculo:  false,
      ultimoRPM:  false
  
    },
    colunasDashboardTelemetria: {
      ignicao: true,
      veiculo: true,
      placa: true,
      motorista:  true,
      odometro:  true,
      horimetro:  true,
      combustivel: true,
      temperaturaMotor: true,
      pressaoOleo: true,
      pesoNoEixo: true,
      velocidade: true,
      rpm: true,
      indicadores: true
    },
    menuFrotaConfigCards: {
      controleFrota: false, pontosInteresse: false, abastecimentoInterno: false, controleEstoque:false 
    }
}

export default state
